type Listener = (waiting: ServiceWorker) => void;

const listeners = new Set<Listener>();
let waitingWorker: ServiceWorker | null = null;

function announce(worker: ServiceWorker) {
  waitingWorker = worker;
  listeners.forEach((listener) => listener(worker));
}

/** Registers /sw.js in production builds and reports when a new version is waiting. */
export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
      if (registration.waiting && navigator.serviceWorker.controller) announce(registration.waiting);
      registration.addEventListener("updatefound", () => {
        const installing = registration.installing;
        installing?.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) announce(installing);
        });
      });
      // Look for a new version when the app comes back to the foreground.
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") void registration.update();
      });
    } catch (error) {
      console.warn("service worker registration failed", error);
    }
  });

  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}

export function onUpdateReady(listener: Listener): () => void {
  listeners.add(listener);
  if (waitingWorker) listener(waitingWorker);
  return () => listeners.delete(listener);
}

export function applyUpdate() {
  waitingWorker?.postMessage({ type: "SKIP_WAITING" });
}
